/*
 * @Author        : turbo 664120459@qq.com
 * @Date          : 2024-02-17 13:48:30
 * @LastEditors   : turbo 664120459@qq.com
 * @LastEditTime  : 2024-02-17 16:27:40
 * @FilePath      : /fm_mobile/src/service/server.js
 * @Description   : 
 * 
 * Copyright (c) 2024 by turbo 664120459@qq.com, All Rights Reserved. 
 */
/* eslint-disable */
import axios from 'axios';
import qs from 'qs';
import { Toast } from 'vant';
import store from '@/store';
import router from '@/router';
import Util from '@/utils/util';
import Auth from '@/utils/auth';
// 创建axios实例
const service = axios.create({
    // baseURL: "http://m.aotuyuzhou.com/", // api的base_url
    timeout: 15000// 请求超时时间
});

const needLogin = () => {
    router.push({
        path: '/login'
    });
};
// 请求拦截器
service.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
    console.log("请求拦截器", config, !(config.data instanceof FormData));
    if (config.showloading) {
        config.toastLoding = Loading(config.showloading !== true ? config.showloading : '加载中...');
    }
    var token = Auth.getToken();
    var uid = Auth.getUid();
    config.headers.common.Token = token ? token : '';
    // config.headers.common.uid = uid ? uid : ''
    config.headers.common.version = '1.7.2';
    config.headers.common.agent = 'webh5';
    if (!(config.data instanceof FormData)) {
        config.data = qs.stringify(config.data);
    }
    return config;
}, function (error) {
    // 对请求错误做些什么
    console.log('请求错误拦截器', config);
    return Promise.reject(error);
});

// respone拦截器
service.interceptors.response.use(
    response => {
        console.log('响应拦截器', response);
        if (response.config.showloading && response.config.toastLoding) {
            response.config.toastLoding.close();
        }
        if (response.status !== '200' && response.status !== 200) {
            Error(response.data.msg || '服务繁忙，请稍候再试');
            return Promise.reject('error');
        }
        const res = response.data;
        if (res.code === '401' || res.code === 401) {
            needLogin();
            return Promise.reject('needLogin');
        }
        if (res.code < 1) {
            Error(response.data.msg || '服务繁忙，请稍候再试');
            return Promise.reject(res);
        } else if (response.config.showResult) {
            Success(response.data.msg || '操作成功');
        }
        return res;
    },
    error => {
        var response = error.response;
        console.log('错误拦截', error);
        if (response.status === 401 || response.status === '401') {
            needLogin();
            return Promise.reject('needLogin');
        }
        // alert(response.status)
        response.message = response.data.msg || '服务器繁忙，稍后再试';
        // if (typeof response.config.showErrorMsg == 'undefined' || response.config.showErrorMsg !== false)
        Error(response.message);
        return Promise.reject(response);
    }
);

export default service;
